import * as React from "react";

import { NewDropdown } from "../NewDropdown/NewDropdown";
import styles from "./docsPaginatorTemplate.module.css";

export const docsPaginatorTemplate = {
  layout: `CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink`,
  CurrentPageReport: (options) => (
    <span className={styles[`pagination-count`]}>
      {`Показано ${options.first}–${options.last} из ${options.totalRecords}`}
    </span>
  ),
  RowsPerPageDropdown: (options) => (
    <span className={styles[`rows-select`]}>
      <NewDropdown
        value={options.value}
        options={options.options}
        onChange={options.onChange}
        disabled={options.disabled}
        className={styles[`rows-dropdown`]}
        aria-label="Строк на странице" />
    </span>
  ),
  FirstPageLink: (options) => (
    <button
      type="button"
      className={`${styles[`pagination-arrow`]} ${styles[`pagination-arrow-first`]}`}
      onClick={options.onClick}
      disabled={options.disabled}>
      <i className="fa-solid fa-angles-left" aria-hidden="true" />
    </button>
  ),
  PrevPageLink: (options) => (
    <button
      type="button"
      className={`${styles[`pagination-arrow`]} ${styles[`pagination-arrow-prev`]}`}
      onClick={options.onClick}
      disabled={options.disabled}>
      <i className="fa-solid fa-chevron-left" aria-hidden="true" />
    </button>
  ),
  PageLinks: (options) => {
    const isActive = options.page === options.currentPage;
    return (
      <button
        type="button"
        key={options.page}
        className={`${styles[`pagination-pill`]} ${isActive ? styles[`pagination-pill-active`] : ``}`}
        onClick={options.onClick}>
        {options.page + 1}
      </button>
    );
  },
  NextPageLink: (options) => (
    <button
      type="button"
      className={`${styles[`pagination-arrow`]} ${styles[`pagination-arrow-next`]}`}
      onClick={options.onClick}
      disabled={options.disabled}>
      <i className="fa-solid fa-chevron-right" aria-hidden="true" />
    </button>
  ),
  LastPageLink: (options) => (
    <button
      type="button"
      className={`${styles[`pagination-arrow`]} ${styles[`pagination-arrow-last`]}`}
      onClick={options.onClick}
      disabled={options.disabled}>
      <i className="fa-solid fa-angles-right" aria-hidden="true" />
    </button>
  ),
};
